import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { BaseDisplayModel } from '@common/models/baseDisplayModel';

export class CompleteCancelModalModel extends BaseDisplayModel {
    completedDate: Date;
    remarkComplete: string;
    cancelledDate: Date;
    remarkCancel: string;

    constructor(data: CompleteCancelModalModel = null) {
        super();

        if (data) {
            Object.assign(this, data);
        }
    }

    generateGroup() {
        const form = new UntypedFormGroup({
            date: new UntypedFormControl({ value: null, disabled: false }),
            remark: new UntypedFormControl({ value: null, disabled: false })
        });
        return form;
    }
}
